import './HistoricalReplayGrid.css';

import { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { UtilsService } from '../../../services/UtilsService';


// interface HistoricalReplayGridProps {
//     gpsPings: GpsPing[];
//     loadingGpsPings: boolean;
//     rowClicked: GpsPing
// }



export class HistoricalReplayGrid extends Component {

    utilsService = new UtilsService();
    
    
    constructor(props) {
        super(props);
    }

    
    emitRowClicked(gpsPing) {
        if(this.props?.rowClicked) {
            this.props.rowClicked(gpsPing);
        }
    }


    renderTable() {
        if(this.props?.loadingGpsPings === true) {
            return <em>Please wait while we retrieve the historical replay data.</em>;
        } 
        
        else {
            return <DataTable
                value={this.props?.gpsPings} 
                className="p-datatable-sm p-datatable-gridlines p-datatable-striped p-datatable-hover" 
                rowHover={true}
                autoLayout={true}
                scrollable 
                scrollHeight="100%"
                onRowClick={(e) => this.emitRowClicked(e.data)}
            >
                <Column 
                    field="eventDateTime" header="Date Time"
                    body={(row, column) => this.utilsService.formatDateToDefault(row.eventDateTime)}
                ></Column>
                <Column field="jobNumber" header="Job Number" filter={true} filterMatchMode={'contains'}></Column>
                <Column field="ref1" header="Ref 1" filter={true} filterMatchMode={'contains'}></Column>
                <Column field="ref2" header="Ref 2" filter={true} filterMatchMode={'contains'}></Column>
                <Column field="trackingLeg" header="Leg Number"></Column>
                <Column 
                    field="jobEvent" header="Status"
                    body={(row, column) => this.utilsService.jobEventEnumName(row.jobEvent)}
                ></Column>
            </DataTable>
        }
    }
    
    
    render() {
        return <div className="historical-replay-grid">
            {this.renderTable()}
        </div>
    }
}